













import { PayrollChangeRequestStatus } from '@/models';

import Vue from 'vue';
export default Vue.extend({
  name: 'PayrollChangeRequestStatusDisplay',

  props: {
    status: { type: PayrollChangeRequestStatus, required: true }
  },

  computed: {
    getStatusColor(): string {
      return this.status.getCurrentState().color!;
    },

    getStatusMessage(): string {
      return this.status.getCurrentState().message!;
    }
  }
});
